import { MatDialogRef } from "@angular/material/dialog";
import { Component, OnInit } from "@angular/core";
import { DialogService } from 'src/app/services/dialog.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PasswordResetComponent } from '../password-reset/password-reset.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { RegisterComponent } from "../register/register.component";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
    loginForm: UntypedFormGroup;

    internalServerError: boolean = false;

    showProgressBar: boolean = false;

    constructor(private authService: AuthenticationService,
        private dialogService: DialogService,
        private formBuilder: UntypedFormBuilder,
        private dialogRef: MatDialogRef<LoginComponent>) {

        this.loginForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required]],
        });
    }

    ngOnInit(): void {
    }

    revalidate() {
        this.loginForm.controls['email'].setErrors(null);
        this.loginForm.controls['password'].setErrors(null);
    }

    registerDialog() {
            this.dialogService.openDialog(RegisterComponent);
        }

    login() {
        if (this.loginForm.valid) {
            this.showProgressBar = true;
            this.authService.login(this.loginForm.value).then(
                res => {
                    this.showProgressBar = false;
                    this.authService.setLoggedUser(res);
                    this.dialogRef.close();
                }
            ).catch(err => {
                this.showProgressBar = false;

                if (err.status === 0)
                    this.internalServerError = true;

                else {
                    this.loginForm.controls['email'].setErrors({ AuthFailed: true });
                    this.loginForm.controls['password'].setErrors({ AuthFailed: true });
                }

                console.error(err);
            });
        }
    }

    forgotPassword() {
        this.dialogService.openDialog(PasswordResetComponent);
    }
}
